import React, { PureComponent } from 'react';

import { setDisplayName } from '../../../../shared/react-hocs/hoc-helpers';

import withCheckPermission from './check-permission-hoc';

import ProgressBar from './progress-bar';

function withPageContainer(WrappedComponent, { permission } = {}) {
	class WithPageContainer extends PureComponent {
		componentDidMount() {
			const { check, menuConfig, fetchData } = this.props;

			if (permission && !check(permission)) {
				if (menuConfig && menuConfig.availableURIs) {
					const availablePage = menuConfig.availableURIs[0];
					if (availablePage) {
						window.location.href = availablePage;
					}
				}
			} else if (fetchData) {
				fetchData(this.props);
			}
		}

		render() {
			if (!this.props.check(permission)) {
				return (
					<div>403 Forbidden</div>
				);
			}

			if (!this.props.data || this.props.progressBar) {
				return (
					<ProgressBar />
				);
			}

			return (
				<WrappedComponent {...this.props} />
			);
		}
	}

	setDisplayName(WithPageContainer, WrappedComponent);

	return withCheckPermission(WithPageContainer);
}

export default withPageContainer;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/with-page-container.js